// extracted by mini-css-extract-plugin
module.exports = {"contentPageTabs":"ContentsPage_contentPageTabs__3wbsx"};